import script from "./AttributeList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeList.vue?vue&type=script&setup=true&lang=js"

import "./AttributeList.vue?vue&type=style&index=0&id=af7ebed6&lang=scss"

const __exports__ = script;

export default __exports__